export default __webpack_public_path__ + "static/media/male.48852862.png";